import { createFileRoute, redirect } from "@tanstack/react-router";
import { TodayScreen } from "../components/today/TodayScreen";
import { queryClient } from "../lib/queryClient";
import { meQuery, type Me } from "../hooks/useAuth";
import { hasPermission } from "../hooks/useCan";

export const Route = createFileRoute("/_auth/today")({
  staticData: { titleKey: "nav.today", breadcrumbKey: "breadcrumb.operate", breadcrumbN: 1 },
  beforeLoad: () => {
    // Today is everyone's day. Sign-in lands here, so send people who can't
    // see it to their own home: a therapist to their calendar, a trainer to
    // the training calendar.
    const me = queryClient.getQueryData<Me>(meQuery.queryKey);
    if (!me || hasPermission(me, "view_all_bookings")) return;
    if (hasPermission(me, "view_bookings")) throw redirect({ to: "/calendar" });
    if (hasPermission(me, "view_training")) throw redirect({ to: "/trainers" });
  },
  component: TodayScreen,
});
